// extracted by mini-css-extract-plugin
export var locationCard = "_gn-0";